import { COMMA, ENTER } from '@angular/cdk/keycodes';
import type { ElementRef, OnInit } from '@angular/core';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import type { Observable } from 'rxjs';
import { debounceTime, map, of, startWith, switchMap } from 'rxjs';
import type { EntityItemInterface } from '../search-input/select-item.interface';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-chip-selector',
  templateUrl: './chip-selector.component.html',
  styleUrls: ['./chip-selector.component.scss']
})
export class ChipSelectorComponent implements OnInit {
  @ViewChild('itemInput') itemInput: ElementRef<HTMLInputElement>;
  @Input() filter: (args: string) => Observable<EntityItemInterface[]>;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() minSearchCharacters = 3;
  @Input() selectedItems: EntityItemInterface[] = [];
  @Output() selectItemsChanged = new EventEmitter<EntityItemInterface[]>();

  separatorKeysCodes: number[] = [ENTER, COMMA];
  itemsCtrl = new FormControl();

  filteredItems$: Observable<EntityItemInterface[]> = of([]);

  ngOnInit(): void {
    this.filteredItems$ = this.itemsCtrl.valueChanges.pipe(debounceTime(500),
      startWith(null),
      switchMap((value) => {

        if (value && typeof (value) === 'string' && value.length >= this.minSearchCharacters) {
          return this.onFilter(value);
        }

        return of([]);
      }),
    );
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.selectedItems.push(event.option.value as EntityItemInterface);
    this.itemInput.nativeElement.value = '';
    this.itemsCtrl.setValue(null);
    this.selectItemsChanged.emit(this.selectedItems);
  }

  remove(index: number): void {
    if (index >= 0) {
      this.selectedItems.splice(index, 1);
      this.selectItemsChanged.emit(this.selectedItems);
    }
  }

  private onFilter(value: string): Observable<EntityItemInterface[]> {
    return this.filter(value).pipe(map(items => items.filter(item => !this.selectedItems.map(k => k.id).includes(item.id))));
  }
}
